var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewriting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.863 6.582-1.12-1.121.464-.458c.273-.274.697-.315.943-.069l.199.192c.28.28.266.69-.02.984l-.466.472zm-8.1 7.26c-.171.068-.376-.13-.301-.315l.622-1.394L16.202 6l1.128 1.114-6.125 6.132-1.442.595zM7.11 18.51c-1.51 0-2.317-.8-2.317-2.296V8.4c0-1.504.807-2.297 2.317-2.297h7.513l-1.518 1.518H7.24c-.601 0-.923.307-.923.936v7.492c0 .63.322.937.923.937h7.663c.451 0 .773-.308.773-.937v-5.803L17.2 8.72v7.493c0 1.497-.8 2.297-2.167 2.297H7.11z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewriting);
export default __webpack_public_path__ + "static/media/rewriting.b29ca201b2a4150417d9a5e37f8a8867.svg";
export { ForwardRef as ReactComponent };